// extracted by mini-css-extract-plugin
export default {"container":"vmgW8T"};